import React from "react";
import Modal, { ModalTransition } from "@atlaskit/modal-dialog";
import apiClient from "../../api/admin-api-client";
import { toast } from "react-toastify";
import useAsync from "../../hooks/use-async";
import { useTranslation } from "react-i18next";

export default function BlockUserModal({ user, onBlocked, onClose }) {
    const { t } = useTranslation();
    const { run, isPending } = useAsync();
    const remove = () => {
        run(apiClient(`user/${user.id}/block-instantly`, { method: "PATCH"}))
            .then(() => {
                toast.success(t("admin_block_user_success"));
                onBlocked && onBlocked();
            })
            .catch(error => toast.error(t("admin_block_user_error") +  error.message));
    };

    return (
        <>
            <ModalTransition>
                <Modal
                    isLoading={isPending}
                    actions={[
                        { text: t("admin_block_user_block"), onClick: remove, isLoading: isPending },
                        { text: t("admin_block_user_cancel"), onClick: onClose, isDisabled: isPending },
                    ]}
                    onClose={close}
                    heading={t("admin_block_user_heading")}
                    appearance="warning"
                >
                    <p>
                        {t("admin_block_user_p")}
                    </p>
                </Modal>
            </ModalTransition>
        </>
    );
}